import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import { parseId } from '@/helper/id'
import {
    projectsQueryKeyPrefix,
    detailsQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'

export const projectDetailsQueryKeyPrefix = [
    projectsQueryKeyPrefix,
    detailsQueryKeyPrefix,
] as const

export const projectDetailsQueryOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    id: string,
    deletedItemSelection: DeletedItemSelection
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...projectDetailsQueryKeyPrefix, id, deletedItemSelection],
        queryFn: async ({ signal }) => {
            assertNotNullish(clients?.project)

            const response = await clients.project.getProject(
                {
                    id: parseId(id),
                    deletedItemSelection,
                },
                { signal }
            )

            return response
        },
    })

export const useProjectDetails = (
    id: string,
    deletedItemSelection: DeletedItemSelection
) => {
    const clients = useGrpcClients()

    return useSuspenseQuery(
        projectDetailsQueryOptions(clients, id, deletedItemSelection)
    )
}
